export default {
  title: 'default',
  colors: {
    primary: 'rgb(101, 199, 247)',
    secondary: 'rgb(0, 82, 212)',
    danger: '#ff0000',
    dark: '#1A1423',
    light: '#f0f0f0',
    background: '#f0f0f0',
    text: '#444',
  },
};
